'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["singleLine"];
import I18n from 'I18n';
import memoize from 'transmute/memoize';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasSubProperty, getPrimaryPropertyName, getSubPropertyName } from 'feedback-utils/tokenUtils';
import { OWNER_PROPERTIES } from 'feedback-schema/constants/ownerUserProperties';
import { jsx as _jsx } from "react/jsx-runtime";
const EXTRACT_TOKEN_PROPERTY_REGEX = /{{\s(?:personalization_token\(["|'])?(\w*)\.(\w*(\.\w*)?)(?:(["|']),\s)?(?:[^{}]*(["|'])\))?\s}}/gm;
export const getTicketTokenProperties = () => ({
  groups: [{
    properties: [{
      label: I18n.text('feedback-shared.tokens.ticket.id'),
      name: 'hs_ticket_id'
    }, {
      label: I18n.text('feedback-shared.tokens.ticket.subject'),
      name: 'subject'
    }]
  }]
});
export const getExtractTokenPropertyRegex = () => new RegExp(EXTRACT_TOKEN_PROPERTY_REGEX);
const flattenGroup = group => group.properties.reduce((propertyAcc, property) => Object.assign({}, propertyAcc, {
  [property.name]: property
}), {});
export const flattenObjectProperties = memoize(objectProperties => objectProperties.reduce((groupAcc, group) => Object.assign({}, groupAcc, flattenGroup(group)), {}));
const getFormattedTextArray = (text = '') => {
  const textArray = text.split(/<br ?\/>/);
  const formattedTextArray = [];
  textArray.forEach(val => {
    formattedTextArray.push(val);
    formattedTextArray.push( /*#__PURE__*/_jsx("br", {}));
  });
  formattedTextArray.pop();
  return formattedTextArray;
};
const insertContactToken = (result, propertiesByType, stringPartsArray) => {
  // eslint-disable-next-line
  let [_, propertyType, propertyName] = result;
  const containsSubToken = hasSubProperty(propertyName);
  const primaryTokenName = containsSubToken ? getPrimaryPropertyName(propertyName) : propertyName;
  const properties = propertiesByType[propertyType] || {};
  const property = properties[primaryTokenName] || undefined;
  let token = property ? property.label : propertyName;
  if (containsSubToken) {
    const subTokenName = OWNER_PROPERTIES[getSubPropertyName(propertyName)].label;
    token = `${token}: ${subTokenName}`;
  }
  propertyType = propertyType || 'contact';
  stringPartsArray.push( /*#__PURE__*/_jsx("span", {
    className: `static-tag-decorator ${propertyType}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `feedback-shared.token.${propertyType}`,
      options: {
        token
      }
    })
  }, stringPartsArray.length));
};
export const renderStyledTagText = (text = '', {
  groups: contactProperties = []
} = {}, {
  groups: ticketProperties = []
} = {}, props = {}) => {
  const {
      singleLine
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const flattenedContactProperties = flattenObjectProperties(contactProperties);
  const flattenedTicketProperties = flattenObjectProperties(ticketProperties);
  const flattenedPropertiesByType = {
    contact: flattenedContactProperties,
    ticket: flattenedTicketProperties
  };
  const stringParts = [];
  const formattedTextArray = getFormattedTextArray(text.replace(/<br>/gi, '<br />'));
  formattedTextArray.forEach(textVal => {
    if (textVal.type === 'br') {
      if (!singleLine) {
        stringParts.push( /*#__PURE__*/_jsx("br", {}, stringParts.length));
      }
    } else {
      const customTokenRegex = getExtractTokenPropertyRegex();
      let result = customTokenRegex.exec(textVal);
      let lastIndex = 0;
      while (result) {
        // pushes first part of string that doesn't have contact token
        if (result.index > lastIndex) {
          stringParts.push( /*#__PURE__*/_jsx("span", {
            children: textVal.slice(lastIndex, result.index)
          }, stringParts.length));
        }

        // pushes contact token into its own styled span
        insertContactToken(result, flattenedPropertiesByType, stringParts);
        lastIndex = result.index + result[0].length;
        result = customTokenRegex.exec(textVal);
      }

      // pushes any remaining string into new span
      if (lastIndex < textVal.length) {
        stringParts.push( /*#__PURE__*/_jsx("span", {
          children: textVal.slice(lastIndex, textVal.length)
        }, stringParts.length));
      }
    }
  });
  return /*#__PURE__*/_jsx("span", Object.assign({}, otherProps, {
    children: stringParts
  }));
};